import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import IconButtonSetting from "../../../../../../../components/Button/IconButtonSetting";
import { Renin_TableData } from "./Get_Renin_table";


export default function Renin_Variants() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>   

<IconButton onClick={handleOpen} size="small" >
        <IconButtonSetting />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

        title='Renin Angiotensin System - Variants'

        content={ <Renin_TableData />}

/>

</>
)}